import { h } from 'preact';

import { getContext } from '../services/context';


export default props => {
    const { base_code, content_text } = getContext();
    return content_text?.[base_code]?.[props.id];
};
